/* ========================================
   INCRED GOLF — SPEC SHEET
   Production JS (Shopify theme)
   ======================================== */

(function() {
  'use strict';

  /* ── Config ── */
  var WORKER_URL = 'https://spec-sheet.cmo-08f.workers.dev';
  var KLAVIYO_COMPANY_ID = 'VAxK25';
  var KLAVIYO_SPEC_LEADS_LIST_ID = 'RkAfVt';

  /* ── Spec Config (product data) ── */
  var SPEC_CONFIG = {
    series: {
      rfb: { name: 'The RFB\u00ae Series', badge: 'Patented', desc: 'The world\u2019s first face-down putters with Reverse Face Balanced\u00ae Technology. CG in front of the shaft. 500% more forgiving.', img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLET_COPPER_ONE_LINE_00001.jpg?v=1758115161', models: ['rfb-sk1', 'rfb-black-mallet', 'rfb-blade', 'rfb-star'] },
      legacy: { name: 'The Legacy Series', desc: 'Tour-inspired designs with traditional balance. Toe hang and face balanced configurations. Hand-milled Incred precision.', img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLETLEGACYCOPPEROFFSET_00001.jpg', models: ['blade-legacy', 'black-mallet-os', 'rainmaker-os', 'rainmaker-on', 'rainmaker-ds', 'black-mallet-on', 'black-mallet-ds'] },
      cs: { name: 'The CS Series', desc: 'Center-shafted putters with the shaft positioned in the middle of the head. Built for pure pendulum stroke mechanics.', img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/incredstarship_blacksteel_00001.jpg', models: ['black-mallet-cs', 'rainmaker-cs', 'rainmaker-x-cs', 'blade-cs', 'razor-cs', 'starship-ufo'] }
    },
    models: {
      'rfb-sk1': { handle: 'incred-rfb-sk1-putter', name: 'RFB SK1', series: 'rfb', variants: ['regular','counterbalanced','armlock','broomstick'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/Sk1_copper_00001_d6a17fdc-542f-4302-ad11-9faf3f816bd6.jpg?v=1758038134' },
      'rfb-black-mallet': { handle: 'incred-rfb-blackmallet-putter', name: 'RFB Black Mallet', series: 'rfb', variants: ['regular','counterbalanced','armlock','broomstick'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLET_COPPER_ONE_LINE_00001.jpg?v=1758115161' },
      'rfb-blade': { handle: 'incred-rfb-blade-putter', name: 'RFB Blade', series: 'rfb', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/incredblade_blacksteel_00001_03c483e8-6517-48a7-8831-aeb5d4e138ad.jpg?v=1758117432' },
      'rfb-star': { handle: 'incred-rfb-star-putter', name: 'RFB Star', series: 'rfb', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/RFB_STAR_COPPER_00001_784aaacb-9430-40fd-8254-7c8853ff37fb.jpg?v=1758115188' },
      'blade-legacy': { handle: 'incred-blade-legacy-putter', name: 'Blade Legacy', series: 'legacy', variants: ['regular','counterbalanced'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLADELEGACY_COPPER_00001.jpg?v=1758115203' },
      'black-mallet-os': { handle: 'incred-blackmallet-legacy-os-putter', name: 'Black Mallet OS', series: 'legacy', variants: ['regular','counterbalanced','broomstick'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLETLEGACYCOPPEROFFSET_00001.jpg?v=1758114768' },
      'rainmaker-os': { handle: 'incred-rainmaker-legacy-os-putter', name: 'Rainmaker OS', series: 'legacy', variants: ['regular','counterbalanced'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/RAINMAKERLEGACYCOPPERoff_00001.jpg?v=1758114754' },
      'rainmaker-on': { handle: 'incred-rainmaker-on-putter', name: 'Rainmaker ON', series: 'legacy', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/RAINMAKERLEGACYCOPPERON_00001.jpg?v=1758115098' },
      'rainmaker-ds': { handle: 'incred-rainmaker-ds-putter', name: 'Rainmaker DS', series: 'legacy', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/RAINMAKERLEGACYCOPPERDS_00001.jpg?v=1758115085' },
      'black-mallet-on': { handle: 'incred-blackmallet-on-putter', name: 'Black Mallet ON', series: 'legacy', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLETLEGACYBLACKSTEEL_ONSET_00001.jpg?v=1758114465' },
      'black-mallet-ds': { handle: 'incred-blackmallet-ds-putter', name: 'Black Mallet DS', series: 'legacy', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLETLEGACYCOPPERSLANTHANDLE_00001.jpg?v=1758114721' },
      'black-mallet-cs': { handle: 'incred-blackmallet-cs-putter', name: 'Black Mallet CS', series: 'cs', variants: ['regular','counterbalanced'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/BLACKMALLET_CS_Copper_THREELINE_00001_efce35eb-e75a-45a1-81bc-48bd1fbbdbe6.jpg?v=1758115172' },
      'rainmaker-cs': { name: 'Rainmaker CS', series: 'cs', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/rainmakercopper_00001.jpg?v=1758115228' },
      'rainmaker-x-cs': { name: 'Rainmaker X CS', series: 'cs', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/rainmakercopper_00001_5766eb87-f265-42f9-b54d-fcec02f269ee.jpg?v=1758117513' },
      'blade-cs': { name: 'Blade CS', series: 'cs', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/incredblade_blacksteel_00001.jpg?v=1758113524' },
      'razor-cs': { name: 'Razor CS', series: 'cs', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/razor_COPPER_00001_0dbf0334-7d1f-416b-a0b8-6bbccd19184d.jpg?v=1758114808' },
      'starship-ufo': { name: 'Starship UFO', series: 'cs', variants: ['regular'], img: 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/incredstarship_blacksteel_00001.jpg?v=1758114791' }
    },
    /* Head-weight envelopes per Nakul's brief (2026-08-14): 350-420g for
       Regular and Counterbalanced, 450-560g for Armlock and Broomstick.
       Length ranges are unchanged — the brief left length unspecified. */
    variantSpecs: {
      regular: { length: [31,38], weight: [350,420] },
      counterbalanced: { length: [35,40], weight: [350,420] },
      armlock: { length: [35,44], weight: [450,560] },
      broomstick: { length: [40,50], weight: [450,560] }
    },

    /* One discrete lie-angle list for every style, not a per-style range.
       Mirrors LIE_ANGLES in scripts/post-checkout-spec-form.html so both spec
       surfaces offer identical options. */
    lieAngles: ['67','68','69','70','71','72','73','76','79'],

    /* Grips are filtered by putter STYLE, not by tier, and carry models.
       Mirrors GRIPS in scripts/post-checkout-spec-form.html — keep the two in
       step, or the pre-purchase and post-checkout forms will offer different
       grips for the same putter. */
    grips: {
      regular: {
        'Garsen': ['Quad Tour Pistol Pro NTS','Quad Tour Pistol Pro NT','Quad Tour','Garsen Max','Garsen Ultimate'],
        'SuperStroke': ['Pistol 1.0','Pistol 2.0','Pistol Tour','Tour 1.0','Tour 2.0','Tour 3.0','Tour 5.0','Flatso 1.0','Flatso 2.0','Flatso 3.0','SS2R','Pistol TLT 2','Claw 1.0','Claw 2.0'],
        'Lamkin Deep Etched': ['Black Cord','Black','White','Blue','Red'],
        'Golf Pride Reverse Taper': ['Flat S','Flat M','Flat L','Round S','Round M','Round L','Pistol S','Pistol M','Pistol L'],
        'Rosemark': ['1.38','1.38 Lite','1.52'],
        'Octogrip': ['R1 11'],
        'Winn': ['DriTac JumboLite','DriTac Midsize']
      },
      counterbalanced: {
        'Garsen': ['Quad Tour Pistol Pro 17','Ultimate 17','Quad Tour 17','Quad Tour 15','Quad Tour Pistol Pro NTS 15','Garsen Max 15'],
        'SuperStroke': ['Tour 3.0 17','Flatso 3.0 17','Tour 1.0 P 17']
      },
      armlock: {
        'SuperStroke': ['Flatso 3.0 17','Wrist Lock 15'],
        'JumboMax': ['JumboFlat 17']
      },
      broomstick: {
        'SuperStroke': ['2 Piece'],
        'Winn': ['2 Piece'],
        'JumboMax': ['2 Piece']
      }
    },

    tiers: {
      /* Stock — ready-built inventory, not a cheaper configuration. Mirrors
         assets/spec-config.js; change both or the two spec surfaces disagree.
         fieldsOnly/lengths/lieAngles are tier-level overrides: without them a
         Stock buyer is offered the global nine lie angles, a 31-38" slider and
         the whole component list, none of which apply to a finished head. */
      stock: {
        price: 549, label: 'Stock', hands: ['Right'],
        shafts: [], headcovers: [], faceMaterials: ['Black PVD Steel'],
        desc: 'Built and ready to ship. Choose length and lie; everything else is already set. (Right-hand only)',
        extras: [],
        fieldsOnly: ['length', 'lieAngle'],
        lengths: ['33', '34', '35'],
        lieAngles: ['68', '69', '70', '71', '72']
      },
      custom: { price: 799, label: 'Custom', hands: ['Right'], shafts: ['Black PVD Steel','Chrome Steel','Graphite'], headcovers: ['Flamingos Blue','Black Stock'], faceMaterials: ['Black PVD Steel','Copper'], desc: 'Steel and graphite shafts, the full grip range, black or copper face. (Right-hand only)', extras: [] },
      premium: { price: 999, label: 'Premium', hands: ['Right'], shafts: ['Black PVD Steel','Chrome Steel','Graphite','Accra','Kinetixx','BGT Stability One'], headcovers: ['Flamingos Blue','Black Stock'], faceMaterials: ['Black PVD Steel','Copper'], desc: 'Every Custom option plus Accra, Kinetixx and BGT Stability One shafts. (Right-hand only)', extras: [] },
      bespoke: { price: 1999, label: 'Bespoke', hands: ['Right','Left'], shafts: ['Black PVD Steel','Chrome Steel','Graphite','Accra','Kinetixx','BGT Stability One'], headcovers: ['Flamingos Blue','Black Stock'], faceMaterials: ['Black PVD Steel','Copper'], desc: 'Full customization + fitting call with Nakul. Left-hand available.', extras: ['engraving','sightLines','faceAngle','paintColors','faceGrooves'] }
    },
    sightLines: ['Single Line','Double Line','Triple Line','Dot','T-Line','Circle','No Line','Custom'],
    paintColors: [{n:'Black',c:'ss-swatch-black'},{n:'White',c:'ss-swatch-white-paint'},{n:'Yellow',c:'ss-swatch-yellow'},{n:'Red',c:'ss-swatch-red'},{n:'Blue',c:'ss-swatch-blue'},{n:'Fl. Yellow',c:'ss-swatch-fl-yellow'},{n:'Fl. Pink',c:'ss-swatch-fl-pink'},{n:'Fl. Red',c:'ss-swatch-fl-red'},{n:'Fl. Orange',c:'ss-swatch-fl-orange'}],
    faceGrooves: ['Standard','Deep Mill','Diamond','Micro-Groove','Smooth'],
    faceMaterialColors: { 'Black PVD Steel': 'ss-swatch-black-steel', Copper: 'ss-swatch-copper' },

    /* Photos for the grip / headcover / shaft option cards, keyed by the exact
       option label used in the tier config above. A label with no entry here
       renders as a text-only card, so this map can be filled in one option at a
       time as product photography lands. Use Shopify CDN URLs. */
    optionImages: {
      // 'Garsen': 'https://cdn.shopify.com/s/files/1/0704/8157/6109/files/grip-garsen.jpg',
      // 'SuperStroke': '...', '2Thumb': '...', 'Octagrip': '...', 'JumboMax': '...', 'Winn': '...',
      // 'Stock Black': '...', 'Flamingos Blue': '...', 'Premium Leather': '...', 'Bespoke Leather': '...',
    }
  };

  /* ── Application State ── */
  var state = {
    mode: 'pre',
    orderId: null,
    orderEmail: null,
    user: { name: '', email: '', phone: '', hearAbout: '' },
    product: { series: null, model: null, tier: null, variant: null },
    specs: {
      hand: 'Right', length: '34', lieAngle: '70', weight: '370', loft: '3',
      shaft: null, gripBrand: null, grip: null, headcover: null, faceMaterial: null,
      engraving: '', sightLines: null, faceAngle: '0', paintColor: null, faceGrooves: null,
      notes: ''
    },
    history: [],
    forward: [],
    currentScreen: null
  };

  var currentScreenEl = null;

  /* ── Helpers ── */
  function $(id) { return document.getElementById(id); }
  function esc(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Screen Management ── */
  function goToScreen(name) {
    if (state.currentScreen) state.history.push(state.currentScreen);
    state.forward = [];
    showScreen(name);
  }

  /* Phase-0 instrumentation. The flow only ever reported form_start and
     form_submit, so every drop-off between them was invisible and there was
     no baseline to compare a pre-purchase configurator against. */
  var SCREEN_ORDER = ['gate', 'product', 'specs', 'bespoke', 'review', 'submitted'];
  function trackStep(event, name, extra) {
    if (typeof gtag !== 'function') return;
    var payload = {
      form_id: 'spec-sheet',
      form_name: 'Spec Sheet',
      spec_mode: state.mode,
      step_name: name,
      step_index: SCREEN_ORDER.indexOf(name) + 1
    };
    if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) payload[k] = extra[k]; } }
    gtag('event', event, payload);
  }

  function showScreen(name) {
    var target = $('ss-screen-' + name);
    if (!target) return;

    trackStep('spec_step_view', name, {
      spec_tier: state.product.tier || '',
      spec_model: state.product.model || ''
    });

    if (currentScreenEl) {
      currentScreenEl.classList.remove('visible');
      currentScreenEl.classList.add('exit-left');
      var old = currentScreenEl;
      setTimeout(function() { old.classList.remove('active', 'exit-left'); }, 500);
    }

    state.currentScreen = name;
    setTimeout(function() {
      target.classList.add('active');
      window.scrollTo(0, 0);
      requestAnimationFrame(function() {
        target.classList.add('visible');
        currentScreenEl = target;
        updateProgress();
        updateStickyProduct();
        updateNavArrows();
      });
    }, currentScreenEl ? 200 : 0);
  }

  function goBack() {
    if (state.history.length === 0) return;
    state.forward.push(state.currentScreen);
    var prev = state.history.pop();
    showScreen(prev);
  }

  function goForward() {
    if (state.forward.length === 0) return;
    state.history.push(state.currentScreen);
    var next = state.forward.pop();
    showScreen(next);
  }

  function updateNavArrows() {
    var backBtn = $('ss-navBack');
    var fwdBtn = $('ss-navForward');
    if (backBtn) backBtn.disabled = state.history.length === 0 || state.currentScreen === 'gate';
    if (fwdBtn) fwdBtn.disabled = state.forward.length === 0;
  }

  /* ── Progress Bar ── */
  function updateProgress() {
    var total = getRelevantScreenCount();
    var current = getRelevantScreenIndex();
    var pct = total > 1 ? (current / (total - 1)) * 100 : 0;
    $('ss-progressBar').style.width = pct + '%';
  }

  function getRelevantScreenCount() {
    var count = state.mode === 'pre' ? 5 : 3;
    if (state.product.tier === 'bespoke') count++;
    return count;
  }

  function getRelevantScreenIndex() {
    var seq = [];
    if (state.mode === 'pre') { seq.push('gate', 'product'); }
    seq.push('specs');
    if (state.product.tier === 'bespoke') seq.push('bespoke');
    seq.push('review', 'submitted');
    return seq.indexOf(state.currentScreen);
  }

  function updateStickyProduct() {
    var model = SPEC_CONFIG.models[state.product.model];
    var tier = SPEC_CONFIG.tiers[state.product.tier];
    if (model && tier) {
      $('ss-stickyProduct').textContent = model.name + ' / ' + tier.label;
    }
  }

  /* ── Sticky Header Scroll ── */
  window.addEventListener('scroll', function() {
    var sh = $('ss-stickyHeader');
    var pw = $('ss-progressWrap');
    if (!sh || !pw) return;
    if (window.scrollY > 120 && state.currentScreen !== 'gate') {
      sh.classList.add('visible');
      pw.classList.add('pushed');
    } else {
      sh.classList.remove('visible');
      pw.classList.remove('pushed');
    }
  });

  /* ── Gate Screen ── */
  function submitGate() {
    var name = $('ss-gateName').value.trim();
    var email = $('ss-gateEmail').value.trim();
    var rawPhone = $('ss-gatePhone') ? $('ss-gatePhone').value.trim() : '';
    var dialEl = $('ss-dialcode');
    var phone = rawPhone ? (rawPhone.charAt(0) === '+' ? rawPhone : ((dialEl ? dialEl.value + ' ' : '') + rawPhone)) : '';
    var hearEl = $('ss-hear');
    var errorEl = $('ss-gateError');

    if (!email || !isValidEmail(email)) {
      $('ss-gateEmail').focus();
      $('ss-gateEmail').style.borderColor = '#c0392b';
      if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.classList.add('visible'); }
      return;
    }
    if (errorEl) errorEl.classList.remove('visible');

    state.user.name = name;
    state.user.email = email;
    state.user.phone = phone;
    state.user.hearAbout = hearEl ? hearEl.value : '';

    if (typeof gtag === 'function') {
      gtag('event', 'form_start', { form_id: 'spec-sheet', form_name: 'Spec Sheet' });
      gtag('event', 'generate_lead', { form_id: 'spec-sheet', form_name: 'Spec Sheet' });
    }

    // Subscribe to Klaviyo "Spec Sheet Leads" list (client-side API)
    if (KLAVIYO_SPEC_LEADS_LIST_ID) {
      subscribeToKlaviyo(email, name);
    }

    // CRM: record the lead now, so someone who stops before the final screen
    // still reaches Airtable (the Klaviyo call above never did that)
    fetch(WORKER_URL + '/spec-start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email, name: name, phone: phone, hearAbout: state.user.hearAbout,
        attribution: (window.IGAttribution && window.IGAttribution.properties()) || {}
      })
    }).catch(function() {});

    // If product, tier, and variant are all pre-filled via URL, skip to specs
    if (state.product.model && state.product.tier && state.product.variant) {
      goToScreen('specs');
      buildSpecsScreen();
    } else {
      goToScreen('product');
      buildSeriesCards();
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function subscribeToKlaviyo(email, firstName) {
    var igAttr = (window.IGAttribution && window.IGAttribution.properties()) || {};
    var props = { '$source': 'Spec Sheet Lead' };
    for (var __k in igAttr) props[__k] = igAttr[__k];
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Spec Sheet',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: props
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_SPEC_LEADS_LIST_ID } }
          }
        }
      })
    }).catch(function() {});
  }

  /* ── Product Select: Series ── */
  function buildSeriesCards() {
    var container = $('ss-seriesCards');
    container.innerHTML = '';
    Object.keys(SPEC_CONFIG.series).forEach(function(key) {
      var s = SPEC_CONFIG.series[key];
      var card = document.createElement('div');
      card.className = 'ss-select-card ss-series-card';
      card.setAttribute('data-series', key);
      card.innerHTML =
        (s.badge ? '<div class="ss-select-card-badge">' + esc(s.badge) + '</div>' : '') +
        '<div class="ss-series-card-img"><img src="' + s.img + (s.img.indexOf('?') !== -1 ? '&' : '?') + 'width=600" alt="' + esc(s.name) + '" loading="lazy"></div>' +
        '<div class="ss-series-card-body">' +
          '<div class="ss-series-card-title">' + s.name + '</div>' +
          '<div class="ss-series-card-desc">' + esc(s.desc) + '</div>' +
        '</div>';
      card.addEventListener('click', function() { selectSeries(key, card); });
      container.appendChild(card);
    });
  }

  function selectSeries(key, cardEl) {
    state.product.series = key;
    var cards = document.querySelectorAll('#ss-seriesCards .ss-select-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('active');
    cardEl.classList.add('active');
    setTimeout(function() {
      showSubstep('model');
      buildModelCards(key);
    }, 300);
  }

  /* ── Product Select: Model ── */
  function buildModelCards(seriesKey) {
    var container = $('ss-modelCards');
    var series = SPEC_CONFIG.series[seriesKey];
    container.innerHTML = '';
    $('ss-modelSubtitle').textContent = series.name + ' \u2014 select a head shape.';
    series.models.forEach(function(modelKey) {
      var m = SPEC_CONFIG.models[modelKey];
      var card = document.createElement('div');
      card.className = 'ss-select-card ss-model-card';
      card.innerHTML =
        '<div class="ss-model-card-img">' + (m.img ? '<img src="' + m.img + (m.img.indexOf('?') !== -1 ? '&' : '?') + 'width=400" alt="' + esc(m.name) + '" loading="lazy">' : esc(m.name)) + '</div>' +
        '<div class="ss-model-card-body">' +
          '<div class="ss-select-card-title">' + esc(m.name) + '</div>' +
          '<div class="ss-select-card-sub">' + m.variants.length + ' variant' + (m.variants.length > 1 ? 's' : '') + '</div>' +
        '</div>';
      card.addEventListener('click', function() { selectModel(modelKey, card); });
      container.appendChild(card);
    });
  }

  function selectModel(key, cardEl) {
    state.product.model = key;
    var cards = document.querySelectorAll('#ss-modelCards .ss-select-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('active');
    cardEl.classList.add('active');
    setTimeout(function() {
      showSubstep('tier');
      buildTierCards();
    }, 300);
  }

  /* ── Product Select: Tier ── */
  function buildTierCards() {
    var container = $('ss-tierCards');
    container.innerHTML = '';
    Object.keys(SPEC_CONFIG.tiers).forEach(function(key) {
      var t = SPEC_CONFIG.tiers[key];
      var card = document.createElement('div');
      card.className = 'ss-select-card ss-tier-card';
      card.innerHTML =
        '<div class="ss-tier-price">$' + t.price.toLocaleString() + '</div>' +
        '<div class="ss-tier-name">' + esc(t.label) + '</div>' +
        '<div class="ss-tier-desc">' + esc(t.desc) + '</div>';
      card.addEventListener('click', function() { selectTier(key, card); });
      container.appendChild(card);
    });
  }

  function selectTier(key, cardEl) {
    state.product.tier = key;
    var cards = document.querySelectorAll('#ss-tierCards .ss-select-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('active');
    cardEl.classList.add('active');
    setTimeout(function() {
      showSubstep('variant');
      buildVariantPills();
    }, 300);
  }

  /* ── Product Select: Variant ── */
  function buildVariantPills() {
    var model = SPEC_CONFIG.models[state.product.model];
    var container = $('ss-variantPills');
    container.innerHTML = '';
    var labels = { regular: 'Regular', counterbalanced: 'Counterbalanced', armlock: 'Armlock', broomstick: 'Broomstick' };
    model.variants.forEach(function(v) {
      var pill = document.createElement('button');
      pill.className = 'ss-variant-pill';
      pill.textContent = labels[v];
      pill.addEventListener('click', function() {
        state.product.variant = v;
        var pills = container.querySelectorAll('.ss-variant-pill');
        for (var i = 0; i < pills.length; i++) pills[i].classList.remove('active');
        pill.classList.add('active');
        $('ss-variantContinue').style.display = '';
      });
      container.appendChild(pill);
    });
    if (model.variants.length === 1) {
      state.product.variant = model.variants[0];
      container.children[0].classList.add('active');
      $('ss-variantContinue').style.display = '';
    }
  }

  function finishProductSelect() {
    goToScreen('specs');
    buildSpecsScreen();
  }

  function showSubstep(name) {
    if (typeof gtag === 'function') {
      gtag('event', 'spec_substep_view', {
        form_id: 'spec-sheet',
        form_name: 'Spec Sheet',
        spec_mode: state.mode,
        substep_name: name
      });
    }
    var substeps = document.querySelectorAll('#ss-screen-product .ss-substep');
    for (var i = 0; i < substeps.length; i++) substeps[i].classList.remove('active');
    $('ss-substep-' + name).classList.add('active');
  }

  /* ── Specs Screen Setup ── */
  function buildSpecsScreen() {
    var model = SPEC_CONFIG.models[state.product.model];
    var tier = SPEC_CONFIG.tiers[state.product.tier];
    var variant = SPEC_CONFIG.variantSpecs[state.product.variant];
    var isBespoke = state.product.tier === 'bespoke';

    $('ss-barName').textContent = model.name;
    $('ss-barMeta').textContent = tier.label + ' / ' + state.product.variant.charAt(0).toUpperCase() + state.product.variant.slice(1);

    /* A tier may narrow what can still be chosen. Stock is existing inventory,
       so only the two things adjustable on a finished head are offered. */
    if (tier.lengths && tier.lengths.length) {
      var lo = parseFloat(tier.lengths[0]);
      var hi = parseFloat(tier.lengths[tier.lengths.length - 1]);
      setupSlider('length', lo, hi, parseFloat(tier.lengths[Math.floor(tier.lengths.length / 2)]), 1, '"');
    } else {
      setupSlider('length', variant.length[0], variant.length[1], Math.round((variant.length[0]+variant.length[1])/2), 0.5, '"');
    }
    setupSlider('weight', variant.weight[0], variant.weight[1], Math.round((variant.weight[0]+variant.weight[1])/2 / 5) * 5, 5, 'g');
    var RULES = window.IG_SPEC_RULES || {};
    buildOptionCards('ss-lieCards', tier.lieAngles || SPEC_CONFIG.lieAngles, 'lieAngle', '70', '\u00b0');
    /* Loft is no longer asked (Nakul, 2026-09-19): every build is the standard 3°.
       state.specs.loft keeps that value so the review and the payload state it. */
    state.specs.loft = (RULES.defaults && RULES.defaults.loft) || '3';

    applyHandAvailability(tier.hands || ['Right']);
    buildOptionCards('ss-shaftCards', tier.shafts, 'shaft');
    buildGripCards(state.product.variant);
    buildOptionCards('ss-headcoverCards', tier.headcovers, 'headcover');
    buildFaceMaterialSwatches(tier.faceMaterials);

    applyFieldsOnly(tier.fieldsOnly);

    if (isBespoke) {
      $('ss-barNameBespoke').textContent = model.name;
      buildOptionCards('ss-faceAngleCards', RULES.faceAngles || ['0','1','2','3','4','5'], 'faceAngle', '0', '\u00b0');
      buildOptionCards('ss-sightLineCards', SPEC_CONFIG.sightLines, 'sightLines');
      buildOptionCards('ss-faceGrooveCards', SPEC_CONFIG.faceGrooves, 'faceGrooves');
      buildPaintColorSwatches();
    }
  }

  /* Show only the fields a tier still allows. `only` is a whitelist of field
     keys; anything absent has its whole .ss-field-group hidden, and the
     Components heading goes too once nothing under it is left. Passing a falsy
     value restores every field, so switching tiers mid-session cannot leave a
     previous tier's hidden fields hidden. */
  var FIELD_ELEMENTS = {
    hand: 'ss-handNote', length: 'ss-lengthSlider', lieAngle: 'ss-lieCards',
    weight: 'ss-weightSlider', shaft: 'ss-shaftCards',
    grip: 'ss-gripCards', headcover: 'ss-headcoverCards',
    faceMaterial: 'ss-faceMaterialSwatches'
  };
  var COMPONENT_FIELDS = ['shaft', 'grip', 'headcover', 'faceMaterial'];

  function applyFieldsOnly(only) {
    Object.keys(FIELD_ELEMENTS).forEach(function(key) {
      var el = $(FIELD_ELEMENTS[key]);
      if (!el) return;
      var group = el.closest ? el.closest('.ss-field-group') : null;
      if (!group) return;
      group.style.display = (!only || only.indexOf(key) !== -1) ? '' : 'none';
    });
    var hideComponents = !!only && COMPONENT_FIELDS.every(function(k) {
      return only.indexOf(k) === -1;
    });
    var labels = document.querySelectorAll('.ss-section-label');
    Array.prototype.forEach.call(labels, function(l) {
      if ((l.textContent || '').trim() === 'Components') {
        l.style.display = hideComponents ? 'none' : '';
      }
    });
  }

  function setupSlider(key, min, max, val, step, unit) {
    var slider = $('ss-' + key + 'Slider');
    if (!slider) return;
    slider.min = min;
    slider.max = max;
    slider.value = val;
    slider.step = step;
    var valEl = $('ss-' + key + 'Val');
    var minEl = $('ss-' + key + 'Min');
    var maxEl = $('ss-' + key + 'Max');
    if (valEl) valEl.textContent = val + unit;
    if (minEl) minEl.textContent = min + unit;
    if (maxEl) maxEl.textContent = max + unit;
    state.specs[key] = String(val);
  }

  function handleSliderInput(key) {
    var map = { length: ['"','length'], weight: ['g','weight'] };
    var unit = map[key][0];
    var stateKey = map[key][1];
    var slider = $('ss-' + key + 'Slider');
    var val = slider.value;
    var valEl = $('ss-' + key + 'Val');
    if (valEl) {
      valEl.textContent = val + unit;
      var pct = (val - slider.min) / (slider.max - slider.min);
      valEl.style.left = 'calc(' + (pct * 100) + '% + ' + ((0.5 - pct) * 22) + 'px)';
    }
    state.specs[stateKey] = val;
  }

  /* `preferred` picks the initially-active card when the first option is a poor
     default — lie angle runs 67-79, and a buyer who never touches it should
     submit the common 70, not the edge value. */
  /* `suffix` is display-only (the degree sign on Lie Angle / Loft / Face
     Angle). State keeps the bare value — the unit is appended again when the
     spec is summarised and submitted, so storing it here would double it. */
  function buildOptionCards(containerId, options, stateKey, preferred, suffix) {
    var container = $(containerId);
    if (!container) return;
    container.innerHTML = '';
    options.forEach(function(opt) {
      var card = document.createElement('div');
      card.className = 'ss-select-card';
      card.style.padding = '14px 10px';
      var img = SPEC_CONFIG.optionImages[opt];
      card.innerHTML =
        (img ? '<img class="ss-select-card-img" src="' + esc(img) + '" alt="' + esc(opt) + '" loading="lazy">' : '') +
        '<div class="ss-select-card-title" style="font-size:12px">' + esc(opt + (suffix || '')) + '</div>';
      card.addEventListener('click', function() {
        var cards = container.querySelectorAll('.ss-select-card');
        for (var i = 0; i < cards.length; i++) cards[i].classList.remove('active');
        card.classList.add('active');
        state.specs[stateKey] = opt;
      });
      container.appendChild(card);
    });
    if (options.length > 0) {
      var idx = preferred ? options.indexOf(preferred) : -1;
      if (idx < 0) idx = 0;
      container.children[idx].classList.add('active');
      state.specs[stateKey] = options[idx];
    }
  }

  /* Grip is a two-step choice: brand cards, then a model select that repopulates
     when the brand changes. `state.specs.grip` carries "Brand Model" so the
     Worker, Airtable and the build email get one readable string — the same
     shape the post-checkout form submits. */
  function buildGripCards(variant) {
    var container = $('ss-gripCards');
    var modelWrap = $('ss-gripModelWrap');
    if (!container) return;
    var gripData = SPEC_CONFIG.grips[variant] || SPEC_CONFIG.grips.regular;
    var brands = Object.keys(gripData);

    container.innerHTML = '';
    brands.forEach(function(brand) {
      var card = document.createElement('div');
      card.className = 'ss-select-card';
      card.style.padding = '14px 10px';
      var img = SPEC_CONFIG.optionImages[brand];
      card.innerHTML =
        (img ? '<img class="ss-select-card-img" src="' + esc(img) + '" alt="' + esc(brand) + '" loading="lazy">' : '') +
        '<div class="ss-select-card-title" style="font-size:12px">' + esc(brand) + '</div>';
      card.addEventListener('click', function() {
        var cards = container.querySelectorAll('.ss-select-card');
        for (var i = 0; i < cards.length; i++) cards[i].classList.remove('active');
        card.classList.add('active');
        selectGripBrand(brand, gripData[brand]);
      });
      container.appendChild(card);
    });

    if (brands.length > 0) {
      container.children[0].classList.add('active');
      selectGripBrand(brands[0], gripData[brands[0]]);
    } else if (modelWrap) {
      modelWrap.style.display = 'none';
    }
  }

  function selectGripBrand(brand, models) {
    state.specs.gripBrand = brand;
    var select = $('ss-gripModelSelect');
    var wrap = $('ss-gripModelWrap');
    if (!select || !wrap) {
      state.specs.grip = brand;
      return;
    }
    select.innerHTML = '';
    (models || []).forEach(function(m) {
      var opt = document.createElement('option');
      opt.value = m;
      opt.textContent = m;
      select.appendChild(opt);
    });
    // A single-model brand needs no choice — hide the select rather than show
    // a dropdown with one entry, but still record the model.
    wrap.style.display = (models && models.length > 1) ? '' : 'none';
    var first = (models && models.length) ? models[0] : '';
    select.value = first;
    state.specs.grip = first ? brand + ' ' + first : brand;
  }

  function handleGripModelChange() {
    var select = $('ss-gripModelSelect');
    if (!select) return;
    state.specs.grip = state.specs.gripBrand + ' ' + select.value;
  }

  function buildFaceMaterialSwatches(materials) {
    var container = $('ss-faceMaterialSwatches');
    container.innerHTML = '';
    materials.forEach(function(mat) {
      var item = document.createElement('div');
      item.className = 'ss-swatch-item';
      var cls = SPEC_CONFIG.faceMaterialColors[mat] || 'ss-swatch-steel';
      var btn = document.createElement('button');
      btn.className = 'ss-swatch-btn ' + cls;
      btn.addEventListener('click', function() { selectSwatch(btn, 'faceMaterial', mat); });
      var label = document.createElement('div');
      label.className = 'ss-swatch-label';
      label.textContent = mat;
      item.appendChild(btn);
      item.appendChild(label);
      container.appendChild(item);
    });
    if (materials.length > 0) {
      container.querySelector('.ss-swatch-btn').classList.add('active');
      state.specs.faceMaterial = materials[0];
    }
  }

  function buildPaintColorSwatches() {
    var container = $('ss-paintColorSwatches');
    container.innerHTML = '';
    SPEC_CONFIG.paintColors.forEach(function(pc) {
      var item = document.createElement('div');
      item.className = 'ss-swatch-item';
      var btn = document.createElement('button');
      btn.className = 'ss-swatch-btn ' + pc.c;
      btn.addEventListener('click', function() { selectSwatch(btn, 'paintColor', pc.n); });
      var label = document.createElement('div');
      label.className = 'ss-swatch-label';
      label.textContent = pc.n;
      item.appendChild(btn);
      item.appendChild(label);
      container.appendChild(item);
    });
  }

  function selectSwatch(btn, stateKey, value) {
    var btns = btn.closest('.ss-swatch-grid').querySelectorAll('.ss-swatch-btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
    btn.classList.add('active');
    state.specs[stateKey] = value;
  }

  /* Left-hand builds run in the Bespoke tier only. Show the Left toggle when
     the chosen tier supports it, and fall the selection back to Right when it
     does not, so a tier switch can never leave an unbuildable hand on file. */
  function applyHandAvailability(hands) {
    var allowed = {};
    for (var i = 0; i < hands.length; i++) allowed[hands[i]] = true;

    var btns = document.querySelectorAll('.ss-toggle-btn[data-key="hand"]');
    for (var j = 0; j < btns.length; j++) {
      var val = btns[j].getAttribute('data-value');
      var ok = !!allowed[val];
      btns[j].style.display = ok ? '' : 'none';
      if (!ok) btns[j].classList.remove('active');
    }

    if (!allowed[state.specs.hand]) {
      state.specs.hand = hands[0];
      for (var m = 0; m < btns.length; m++) {
        if (btns[m].getAttribute('data-value') === state.specs.hand) btns[m].classList.add('active');
      }
    }

    var note = $('ss-handNote');
    if (note) note.style.display = allowed['Left'] ? 'none' : '';
  }

  function selectToggle(btn, stateKey, value) {
    var btns = btn.parentElement.querySelectorAll('.ss-toggle-btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
    btn.classList.add('active');
    state.specs[stateKey] = value;
  }

  /* ── Navigation Between Spec Screens ── */
  function advanceFromSpecs() {
    if (state.product.tier === 'bespoke') {
      goToScreen('bespoke');
    } else {
      goToScreen('review');
      buildReview();
    }
  }

  function editProduct() {
    state.history = [];
    state.forward = [];
    showScreen('product');
    showSubstep('series');
    buildSeriesCards();
  }

  /* ── Engraving ── */
  function updateEngraving() {
    var input = $('ss-engravingInput');
    var preview = $('ss-engravingPreview');
    var counter = $('ss-charCounter');
    var val = input.value;
    state.specs.engraving = val;
    counter.textContent = val.length + ' / 40';
    counter.className = 'ss-char-counter' + (val.length > 35 ? ' warn' : '');
    preview.innerHTML = val
      ? '<span class="ss-engraving-text">' + esc(val).toUpperCase() + '</span>'
      : '<span class="ss-engraving-placeholder">Your engraving will appear here</span>';
  }

  /* ── Review Screen ── */
  function buildReview() {
    var container = $('ss-reviewContent');
    var model = SPEC_CONFIG.models[state.product.model];
    var s = state.specs;
    var html = '';

    html += reviewSection('Your Putter', [
      ['Model', model.name],
      ['Tier', SPEC_CONFIG.tiers[state.product.tier].label + ' \u2014 $' + SPEC_CONFIG.tiers[state.product.tier].price.toLocaleString()],
      ['Variant', state.product.variant.charAt(0).toUpperCase() + state.product.variant.slice(1)]
    ], 'specs');

    html += reviewSection('Basics', [
      ['Hand', s.hand],
      ['Length', s.length + '"'],
      ['Lie Angle', s.lieAngle + '\u00b0'],
      ['Weight', s.weight + 'g'],
      ['Loft', s.loft + '\u00b0']
    ], 'specs');

    html += reviewSection('Components', [
      ['Shaft', s.shaft],
      ['Grip', s.grip],
      ['Headcover', s.headcover],
      ['Face Material', s.faceMaterial]
    ], 'specs');

    if (state.product.tier === 'bespoke') {
      html += reviewSection('Bespoke Options', [
        ['Laser Engraving', s.engraving || 'None'],
        ['Sight Lines', s.sightLines],
        ['Face Angle', s.faceAngle + '\u00b0'],
        ['Paint Color', s.paintColor || 'None selected'],
        ['Face Grooves', s.faceGrooves]
      ], 'bespoke');
    }

    container.innerHTML = html;
  }

  function reviewSection(title, rows, editTarget) {
    var html = '<div class="ss-review-section">' +
      '<div class="ss-review-section-header">' +
        '<div class="ss-review-section-title">' + esc(title) + '</div>' +
        '<button class="ss-review-edit-btn" data-edit-target="' + editTarget + '">Edit</button>' +
      '</div>';
    rows.forEach(function(row) {
      html += '<div class="ss-review-row">' +
        '<span class="ss-review-row-label">' + esc(row[0]) + '</span>' +
        '<span class="ss-review-row-value">' + esc(row[1] || '\u2014') + '</span>' +
      '</div>';
    });
    html += '</div>';
    return html;
  }

  /* ── Submit ── */
  function submitSpecSheet() {
    state.specs.notes = $('ss-notesInput').value;
    var submitBtn = $('ss-submitBtn');
    var errorEl = $('ss-submitError');

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="ss-spinner"></span> Submitting...';
    if (errorEl) errorEl.classList.remove('visible');

    var payload = {
      type: state.mode === 'post' ? 'order' : 'lead',
      source: state.user.source || 'website',
      orderId: state.orderId || null,
      email: state.mode === 'post' ? state.orderEmail : state.user.email,
      name: state.user.name || '',
      phone: state.user.phone || '',
      hearAbout: state.user.hearAbout || '',
      attribution: (window.IGAttribution && window.IGAttribution.properties()) || {},
      product: {
        series: state.product.series,
        model: state.product.model,
        tier: state.product.tier,
        variant: state.product.variant
      },
      specs: {
        hand: state.specs.hand,
        length: state.specs.length,
        lieAngle: state.specs.lieAngle,
        weight: state.specs.weight,
        loft: state.specs.loft,
        shaft: state.specs.shaft,
        grip: state.specs.grip,
        headcover: state.specs.headcover,
        faceMaterial: state.specs.faceMaterial,
        engraving: state.specs.engraving,
        sightLines: state.specs.sightLines,
        faceAngle: state.specs.faceAngle,
        paintColor: state.specs.paintColor,
        faceGrooves: state.specs.faceGrooves,
        notes: state.specs.notes
      }
    };

    fetch(WORKER_URL + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.success) {
        if (typeof gtag === 'function') {
          gtag('event', 'form_submit', { form_id: 'spec-sheet', form_name: 'Spec Sheet' });
        }
        goToScreen('submitted');
        buildSubmittedScreen();
      } else {
        throw new Error(data.error || 'Submission failed');
      }
    })
    .catch(function(err) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit Your Spec Sheet';
      if (errorEl) {
        errorEl.textContent = 'Something went wrong. Please try again or email help@incred.golf.';
        errorEl.classList.add('visible');
      }
      console.error('Spec sheet submission error:', err);
    });
  }

  function buildSubmittedScreen() {
    var actions = $('ss-submittedActions');
    var subtitle = document.querySelector('#ss-screen-submitted .ss-screen-subtitle');
    if (state.mode === 'pre') {
      // Pre-purchase: 71 of 74 spec sheets never became orders because this screen
      // read like an order confirmation (2026-08-22 diagnosis). Say plainly that
      // nothing is built yet, and send them to the putter they just specced.
      var model = SPEC_CONFIG.models[state.product.model];
      var href = model && model.handle ? '/products/' + model.handle : '/collections/all';
      if (subtitle) subtitle.textContent = 'Your specs are saved and emailed to you. Nothing is built yet \u2014 your putter goes into the build queue when you place your order.';
      actions.innerHTML =
        '<a href="' + href + '" class="ss-btn-primary" style="max-width:320px;margin:0 auto;display:flex;">Order your ' + esc(model ? model.name : 'putter') + ' <span style="margin-left:8px">&rarr;</span></a>' +
        '<p style="margin-top:16px;font-size:13px;color:var(--ss-grey);">Spec sheet sent to ' + esc(state.user.email) + '. Your specs are applied to your order automatically.</p>';
    } else {
      if (subtitle) subtitle.textContent = 'We\u2019ve received your specs. Your putter goes into the build queue now and we\u2019ll email you when it ships.';
      actions.innerHTML =
        '<p style="font-size:14px;color:var(--ss-grey);">Questions about your build?<br><a href="mailto:help@incred.golf" style="color:var(--ss-gold);font-weight:600;">help@incred.golf</a></p>';
    }
  }

  /* ── Event Delegation ── */
  document.addEventListener('click', function(e) {
    var target = e.target;

    // Nav arrows (sticky header)
    if (target.closest('#ss-navBack')) { goBack(); return; }
    if (target.closest('#ss-navForward')) { goForward(); return; }

    // Back buttons (inline)
    if (target.closest('.ss-btn-back')) { goBack(); return; }

    // Gate submit
    if (target.id === 'ss-gateSubmit' || target.closest('#ss-gateSubmit')) { submitGate(); return; }

    // Variant continue
    if (target.id === 'ss-variantContinue' || target.closest('#ss-variantContinue')) { finishProductSelect(); return; }

    // Specs continue
    if (target.id === 'ss-specsContinue' || target.closest('#ss-specsContinue')) { advanceFromSpecs(); return; }

    // Bespoke continue
    if (target.id === 'ss-bespokeContinue' || target.closest('#ss-bespokeContinue')) { goToScreen('review'); buildReview(); return; }

    // Submit
    if (target.id === 'ss-submitBtn' || target.closest('#ss-submitBtn')) { submitSpecSheet(); return; }

    // Product bar edit
    if (target.classList.contains('ss-product-bar-edit')) { editProduct(); return; }

    // Review edit buttons
    if (target.classList.contains('ss-review-edit-btn')) {
      var editTarget = target.getAttribute('data-edit-target');
      goToScreen(editTarget);
      buildSpecsScreen();
      return;
    }

    // Toggle buttons
    if (target.classList.contains('ss-toggle-btn')) {
      var stateKey = target.getAttribute('data-key');
      var value = target.getAttribute('data-value');
      if (stateKey && value) selectToggle(target, stateKey, value);
      return;
    }
  });

  /* ── Slider Event Delegation ── */
  document.addEventListener('input', function(e) {
    if (e.target.id === 'ss-lengthSlider') handleSliderInput('length');
    if (e.target.id === 'ss-weightSlider') handleSliderInput('weight');
    if (e.target.id === 'ss-gripModelSelect') handleGripModelChange();
    if (e.target.id === 'ss-engravingInput') updateEngraving();
  });

  /* ── Init ── */
  function init() {
    var params = new URLSearchParams(window.location.search);

    if (params.get('order')) {
      // POST-PURCHASE MODE
      state.mode = 'post';
      state.orderId = params.get('order');
      state.orderEmail = params.get('email') || '';

      // Read product info from URL params (passed from Klaviyo email)
      var productParam = params.get('product');
      var tierParam = params.get('tier');
      var variantParam = params.get('variant');

      if (productParam && SPEC_CONFIG.models[productParam]) {
        state.product.model = productParam;
        state.product.series = SPEC_CONFIG.models[productParam].series;
      } else {
        // Default fallback
        state.product.series = 'rfb';
        state.product.model = 'rfb-black-mallet';
      }

      state.product.tier = (tierParam && SPEC_CONFIG.tiers[tierParam]) ? tierParam : 'premium';
      state.product.variant = variantParam || 'regular';

      showScreen('specs');
      buildSpecsScreen();

    } else {
      // PRE-PURCHASE MODE
      state.mode = 'pre';

      if (params.get('product')) {
        var modelKey = params.get('product');
        if (SPEC_CONFIG.models[modelKey]) {
          state.product.model = modelKey;
          state.product.series = SPEC_CONFIG.models[modelKey].series;
        }
      }
      if (params.get('tier') && SPEC_CONFIG.tiers[params.get('tier')]) {
        state.product.tier = params.get('tier');
      }
      if (params.get('variant')) {
        var vParam = params.get('variant').toLowerCase();
        if (SPEC_CONFIG.variantSpecs[vParam]) {
          state.product.variant = vParam;
        }
      }
      if (params.get('email')) {
        state.user.email = params.get('email');
        $('ss-gateEmail').value = params.get('email');
      }
      if (params.get('name')) {
        state.user.name = params.get('name');
        $('ss-gateName').value = params.get('name');
      }
      if (params.get('phone') && $('ss-gatePhone')) {
        state.user.phone = params.get('phone');
        $('ss-gatePhone').value = params.get('phone');
      }
      if (params.get('source')) {
        state.user.source = params.get('source');
      }

      // Auto-skip gate if name + email provided (e.g. from influencer form)
      if (state.user.name && state.user.email && params.get('source') === 'influencer') {
        submitGate();
        return;
      }

      showScreen('gate');
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
